/**
 * Copyright (c) Omnissa, LLC. All rights reserved.
 * This product is protected by copyright and intellectual property laws in the
 * United States and other countries as well as by international treaties.
 * -- Omnissa Restricted
 *
 * @format
 */

import { Component, Input, Optional, ViewChild } from "@angular/core";
import { clientUtil } from "@html-core";
import { ClipboardKillSwitchService } from "../desktop/common/clipboard-killswitch.service";
import { FileTransferPanelComponent } from "../desktop/filetransfer/file-transfer.component";

@Component({
   standalone: false,
   selector: "remote-feature",
   templateUrl: "./remote-feature.component.html"
})
export class RemoteFeatureComponent {
   public isWebPanelFreeClipboard: boolean;
   public chromeclient: boolean;
   public isIWAClient: boolean;
   @Input() isApplicationOnChromeclient;
   public session;
   @ViewChild(FileTransferPanelComponent, { static: true }) fileTransfer: FileTransferPanelComponent;
   constructor(private clipboardKillSwitchService: ClipboardKillSwitchService) {
      this.isWebPanelFreeClipboard = this.clipboardKillSwitchService.getIsWebPanelFreeClipboard();
      this.chromeclient = clientUtil.isChromeClient();
      this.isIWAClient = clientUtil.isIwaClient();
   }
}
